<template>
  <div>
    <component :is="menuComponent" :data="data" />
  </div>
</template>

<script>
  export default {
    name: "CSMenu",
    components: {
      CSMenuLeft: () => import('./Menus/CSMenuLeft.vue'),
      CSMenuRight: () => import('./Menus/CSMenuRight.vue'),
      CSMenuJustify: () => import('./Menus/CSMenuJustify.vue'),
      CSMenuCenterDouble: () => import ('./Menus/CSMenuCenterDouble.vue'),
      CSMenuOverlay: () => import('./Menus/CSMenuOverlay.vue')
    },
    props: {
      logo: {
        type:String,
        default:''
      },
      links: {
        type:[Object, Array]
      },
      menuStyle: {
        type:String,
        default:'left'
      },
      menu: {
        type: [Object, Array],
        default: () => {},
      },
    },
    data() {
      return {
        menus: {
          left: 'CSMenuLeft',
          right: 'CSMenuRight',
          justify: 'CSMenuJustify',
          centerDouble: 'CSMenuCenterDouble',
          overlay: 'CSMenuOverlay'
        }
      }
    },
    computed: {
      data(){
        return {
          logo:this.logo,
          links:this.links,
          style:this.menuStyle,
          menu:this.menu,
        }
      },  
      menuComponent() {
        if (this.menuStyle && this.menus[this.menuStyle]) return this.menus[this.menuStyle];
        return 'CSMenuOverlay';
      }
    },
    mounted(){}
  };
</script>